import Service from '../Service'
import { LandingV4Instance } from './Instance'

/**
 * @class
 */
export class ProveService extends Service {


  /**
* @param  {String} creditApplicationId
* @param  {String} phoneNumber
* @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
*/
  postAutUrl(creditApplicationId, phoneNumber, ip) {
    return this._requestWrapper(LandingV4Instance({
      method: 'POST',
      url: '/prove/instantLink/getAuthUrl',
      data: {
        creditApplicationId: `${creditApplicationId}`,
        phoneNumber: `${phoneNumber}`,
        sourceIp: `${ip}`
      }
    }))
  }


  /**
   * @param {String} creditApplicationId
   * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
   */
  getCheckInstantLink(creditApplicationId) {
    return this._requestWrapper(LandingV4Instance({
      method: 'GET',
      url: `/prove/checkInstantLink?creditApplicationId=${creditApplicationId}`
    }))
  }

  /**
   * @param  {String} PostalCode
   * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
   */
  getTrustScore(creditApplicationId, phoneNumber) {
    return this._requestWrapper(LandingV4Instance({
      method: 'GET',
      url: `/prove/trustScore?creditApplicationId=${creditApplicationId}&phoneNumber=${phoneNumber}`
    }))
  }


}